/* AquaBench custom interactions — shared. Safe to load once, idempotent. */
(function () {
  if (window.__wwdAbInit) return;
  window.__wwdAbInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal on scroll ---- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.wwd-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- generic accordions ---- */
  function initAcc(root) {
    (root || document).querySelectorAll('[data-wwd-acc-trigger]').forEach(function (btn) {
      if (btn.__wwd) return; btn.__wwd = true;
      btn.addEventListener('click', function () {
        var item = btn.closest('.wwd-acc__item');
        if (!item) return;
        var openState = !item.classList.contains('is-open');
        var group = btn.closest('[data-wwd-acc]');
        if (group && group.hasAttribute('data-wwd-acc-single')) {
          group.querySelectorAll('.wwd-acc__item.is-open').forEach(function (o) {
            o.classList.remove('is-open');
            var t = o.querySelector('[data-wwd-acc-trigger]'); if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', openState);
        btn.setAttribute('aria-expanded', openState ? 'true' : 'false');
      });
    });
  }

  /* ---- count up for stats ---- */
  function initCount(root) {
    var nums = (root || document).querySelectorAll('[data-wwd-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-wwd-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, target = parseFloat(el.getAttribute('data-wwd-count')) || 0,
            dec = (el.getAttribute('data-wwd-count').split('.')[1] || '').length,
            suf = el.getAttribute('data-wwd-suffix') || '', t0 = null, dur = 1400;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1), ease = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * ease).toFixed(dec) + suf;
          if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec) + suf;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function boot(root) { initReveal(root); initAcc(root); initCount(root); }

  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });

  /* re-init inside Shopify theme editor when sections load */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.wwdAbBoot = boot;
})();
